// Router DOM
import { Link } from 'react-router-dom';

import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import unfoldLess from '../../../../../src/icons/unfold_less.svg';
import unfoldMore from '../../../../../src/icons/unfold_more.svg';

import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import UserInfoIcon from '@material-ui/icons/AccountBoxOutlined';
import SignoutIcon from '@material-ui/icons/ExitToAppOutlined';
import { Grid } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

import AssessmentIcon from '@material-ui/icons/Assessment';
import Fullscreen from '@material-ui/icons/Fullscreen';
import Switch from '@material-ui/core/Switch';

import Button from '@material-ui/core/Button';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';


// Shared services
import { getNotifications } from 'services/notification';
import { getUserInfo } from 'services/userInfo';

// Custom components
import NotificationList from './components/NotificationList';
import UserInfo from './components/UserInfo';
import SectionsTools from '../../../../views/Online/components/SectionsTools';
import {getLastStatusObjective} from '../../../../services/getLastStatusObjective'
import Feedback from './components/Feedback';

//import {getIcon} from '../../../../utils/getIcon'
// Component styles
import styles from './styles';
import icons from '../../../../theme/icons.js'

import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')


class Topbar extends Component {
    signal = true;

    /*  Link externo a servicios atentus */
    services = {
        "atWeb" : "https://atentus.com/monitoreoweb/",
        "atIvr" : "https://atentus.com/monitoreotelefonico/",
        "atMobile": "https://atentus.com/monitoreoaplicaciones/",
        "atMeta": "https://atentus.com/monitoreoweb/"

    };
   
    constructor(props) {
        super(props);
        this.state = {
            notifications: [],
            notificationsLimit: 4,
            notificationsCount: 0,
            notificationsEl: null,
            userDataEl: null,
            userData: [],
            userId: parseInt(sessionStorage.getItem('user')),
            token: (sessionStorage.getItem('key')),
            email: sessionStorage.getItem('email'),
            open:false,
            anchor:null,
            interval:'',
            slaOK:99.0,
            slaError:97.0,
            slaResponse:15.0,
            slaResponseError:29.0,
            value:{},
            sectionEl:null,
            checkedA: sessionStorage.getItem('extend_view') === "true",

        };
    }

    async getNotifications() {
        try {
            const { notificationsLimit } = this.state;

            const { notifications, notificationsCount } = await getNotifications(
                notificationsLimit
            );

            if (this.signal) {
                this.setState({
                    notifications,
                    notificationsCount
                });
            }
        } catch (error) {
            return;
        }
    }

    async getUserInfo() {
        try {

            const { userData } = await getUserInfo(
                this.state.userId
            );

            if (this.signal) {
                this.setState({
                    userData
                });

            }
        } catch (error) {
            return;
        }
    }

    getIcon=(data)=>{
        var icon = <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}/>
        if(data==='0'){
            icon =<i style={{...icons.sprite, ...icons.spriteOK,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />                               
        }else if(data==='27'){
            icon = <i style={{...icons.sprite, ...icons.spriteTIMEOUT_JS,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />
        }else if(data==='13'){
            icon = <i style={{...icons.sprite, ...icons.spriteERROR_CONTENIDO,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />
        }else if(data==='1006'){
            icon = <i style={{...icons.sprite, ...icons.spriteTIMEOUT_DE_LA_OPERACION_DEL_SOCKET,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />
        }else if(data==='3'){
            icon = <i style={{...icons.sprite, ...icons.sprite_TIMEOUT,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />
        }else if(data==='500'){
            icon =<i style={{...icons.sprite, ...icons.sprite500,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />
        }else if(data==='613'){
            icon = <i style={{...icons.sprite, ...icons.spriteERROR_CONTENIDO,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />
        }else if(data==='603'){
            icon = <i style={{...icons.sprite, ...icons.spriteTRONCAL_OCUPADO,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />
        }else if(data==='610'){
            icon = <i style={{...icons.sprite, ...icons.spriteLLAMADA_COLGADA,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />
        }else if(data==='999999'){
            icon = <i style={{...icons.sprite, ...icons.spriteERROR_DESCONOCIDO_EN_SCRIPT,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />
        }else if(data==='607'){
            icon = <i style={{...icons.sprite, ...icons.sprite_TIMEOUT,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />
        }else if(data==='601'){
            icon = <i style={{...icons.sprite, ...icons.spriteTRONCAL_CONGESTIONADO,scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}  />
        } else if(data==='404'){
            icon = <i style={{...icons.sprite, ...icons.sprite404, scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px'}}/>
        }
        else if(data==='1004'){
            icon = <i style={{...icons.sprite, ...icons.spriteTIMEOUT_EN_CONEXION, scale:"0.3",transform:'scale(0.5)', transformOrigin:'left top 0px' }}/>
        }
        return icon
    }


    componentDidMount() {
        this.signal = true;
        this.getNotifications();
        this.getUserInfo();
    }

    componentWillUnmount() {
        this.signal = false;
    }

    handleSignOut = () => {
        const { history } = this.props;
        localStorage.setItem('isAuthenticated', false);
        localStorage.clear()
        sessionStorage.clear()
        history.push('/sign-in');
    };

    handleShowNotifications = event => {
        this.setState({
            notificationsEl: event.currentTarget
        });
    };

    handleCloseNotifications = () => {
        this.setState({
            notificationsEl: null
        });
    };


    handleShowUserInfo = event => {
        this.setState({
            userDataEl: event.currentTarget
        });
    };

    handleSection = event => {
                this.setState({
                    sectionEl: event.currentTarget
                });
    };


    handleSectionClose = () => {
        this.setState({
            sectionEl: null
        });
    };
        

    handleCloseUserInfo = () => {
        this.setState({
            userDataEl: null
        });
    }
        handleSwitch = name=>event => {
            sessionStorage.setItem('extend_view', event.target.checked)
            this.setState({ 
                checkedA: event.target.checked 
            });
            this.props.onHandleExpand(event.target.checked)
    
    };

    openModal=(event)=>{
        var interval=(this.props.location.state.fromObjective.intervalo)
        const {userId, token}=this.state
        var obj=(this.props.location.state.fromObjective.objetivo_id)
        if(interval==='0:01:00'){
            interval='1[m]'
        }
        else if(interval==='0:05:00'){
            interval='5[m]'
        }
        else if(interval==='0:07:00'){
            interval='7[m]'
        }
        else if(interval==='0:10:00'){
            interval='10[m]'
        }
        else if(interval==='0:15:00'){
            interval='15[m]'
        }
        else if(interval==='0:20:00'){
            interval='20[m]'
        }
        else if(interval==='0:30:00'){
            interval='30[m]'
        }
        else if(interval==='0:40:00'){
            interval='40[m]'
        }
        else if(interval==='1:00:00'){
            interval='1[h]'
        }
        else if(interval==='1:30:00'){
            interval='1[h]30[m]'
        }
        else if(interval==='2:00:00'){
            interval='2[h]'
        }
        else if(interval==='6:00:00'){
            interval='6[h]'
        }
        else if(interval==='12:00:00'){
            interval='12[h]'
        }
        else if(interval==='24:00:00'){
            interval='24[h]'
        }
        else if(interval==='7 days'){
            interval='1 Semana'
        }else{
            interval='Mayor a una semana'
        }
        getLastStatusObjective(obj, userId, token).then(value=>{
            if(value.estado==='Error'){
                value.estado=true
            }else{
                value.estado=false
            }
            this.setState({
                open:true,
                anchor:event.currentTarget,
                interval:interval,
                slaOK:this.props.location.state.fromObjective.sla_disponibilidad_ok,
                slaError:this.props.location.state.fromObjective.sla_disponibilidad_error,
                slaResponse:this.props.location.state.fromObjective.sla_rendimiento_ok,
                slaResponseError:this.props.location.state.fromObjective.sla_rendimiento_error,
                value:value
            })
        })
        
    }

    handleClose = () => {
        this.setState({
            anchor: null,
            open:false
        });
    };

    handleShowFeedback=(e)=>{
        this.setState({
            FeedbackEl: e.currentTarget
        });
        
    }

    handleCloseFeedback = () => {
        this.setState({
            FeedbackEl: null,
        });
    };

    render() {
        const {
            classes,
            className,
            title,
            isSidebarOpen,
            onToggleSidebar,
            subtitle,
            location
        } = this.props;

        const { notifications, notificationsCount, notificationsEl, userDataEl, email,open,anchor, interval,slaError, slaOK, slaResponse,
             slaResponseError, value, FeedbackEl , sectionEl, checked, checkedA} = this.state;
        const rootClassName = classNames(classes.root, className);
        const showNotifications = Boolean(notificationsEl);
        const showUserData = Boolean(userDataEl);
        const showFeedback = Boolean(FeedbackEl);

        const section = Boolean(sectionEl);
        let titleBlock = null;
        // Si no tiene subtitulo, es una sección global
        if (!subtitle) {
            titleBlock = (
                <Typography className={classes.title} variant="h4">
                    {title}
                </Typography>
            );
        }else if(title==="Especial"){
            titleBlock = (
                <Typography className={classes.title} variant="h4">
                    {this.props.match.params.nombre_objetivo}
                </Typography>
            );
        
        } else {
            let objectiveStatus=location.state.fromObjective.estado
            var widthScreen={width:"40%", left:"20%"}
            if(window.innerWidth<=360){
                widthScreen={width:"80%", left:"20%"}
            }
            titleBlock = (
                <div>
                    <Badge
                        badgeContent='Offline'
                        variant="dot"
                        classes={{ badge: objectiveStatus == 'Uptime'  ? classes.customBadgeOnlineUp 
                                        :objectiveStatus == 'Downtime'  ? classes.customBadgeOnlineDown
                                        :objectiveStatus == 'Parcial'  ? classes.customBadgeOnlinePartial
                                        :objectiveStatus == 'No monitoreo'  ? classes.customBadgeOnlineNoMon  : null }}
                        //classes={{ badge: classes.customBadgeOnline }}
                    >
                        <Button onClick={this.openModal}>
                            <Typography className={classes.title} variant="h5">
                                {this.props.match.params.nombre_objetivo}
                            </Typography>
                        </Button>
                    </Badge>
                    <Popover open={open}
                        anchorEl={anchor}
                        onClose={this.handleClose}
                        /*
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}*/
                        className={classes.popOverStatus}
                        style={widthScreen}
                    >
                        <Grid container spacing={1} style={{backgroundColor:"#616161"}}>
                            <Grid item xl={5} md={5} xs={5} lg={5}>
                                <Typography className={classes.rowPop}>Intervalo de Ejecución: </Typography>
                            </Grid>
                            <Grid item xl={7} md={7} xs={7} lg={7}>
                                <Typography className={classes.rowPop}>{interval}</Typography>
                            </Grid>
                            <Grid item xl={5} md={5} xs={5} lg={5}style={{backgroundColor:"#757575"}}>
                                <Typography className={classes.rowPop}>Sla Disponibilidad: </Typography>
                            </Grid>
                            <Grid item xl={7} md={7} xs={7} lg={7} style={{backgroundColor:"#757575"}}>
                                <Grid container spacing={1}>
                                    <Grid item xl={12} md={12} xs={12} lg={12} style={{backgroundColor:"#757575"}}>
                                        <Typography className={classes.rowPop}>Ok: {slaOK}% </Typography>
                                    </Grid>
                                    <Grid item xl={12} md={12} xs={12} lg={12} style={{backgroundColor:"#757575"}}>
                                        <Typography className={classes.rowPop}>Error: {slaError}%</Typography> 
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xl={5} md={5} xs={5} lg={5}>
                                <Typography className={classes.rowPop}>Sla Rendimiento: </Typography>
                            </Grid>
                            <Grid item xl={7} md={7} xs={7} lg={7} >
                                <Grid container spacing={1}>
                                    <Grid item xl={12} md={12} xs={12} lg={12}>
                                        <Typography className={classes.rowPop}>Ok: {slaResponse}[s]</Typography>
                                    </Grid>
                                    <Grid item xl={12} md={12} xs={12} lg={12}>
                                        <Typography className={classes.rowPop}>Error: {slaResponseError}[s]</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xl={5} md={5} xs={5} lg={5} style={{backgroundColor:"#757575"}}>
                                <Typography className={classes.rowPop}>Última Medición: </Typography>
                            </Grid>
                            <Grid item xl={7} md={7} xs={7} lg={7} style={{backgroundColor:"#757575"}}>
                                <Typography className={classes.rowPop}>{moment(value.fecha).format("hh:mm:ss DD-MM-YYYY")}</Typography>
                            </Grid>
                            <Grid item xl={5} md={5} xs={5} lg={5}>
                                <Typography className={classes.rowPop}>Isp: </Typography>
                            </Grid>
                            <Grid item xl={7} md={7} xs={7} lg={7}>
                                <Typography className={classes.rowPop}>{value.nodo}</Typography>
                            </Grid>
                            <Grid item xl={5} md={5} xs={5} lg={5}>
                                <Typography className={classes.rowPop}>Estado: </Typography>
                            </Grid>
                            {value.estado?
                                <Grid item xl={7} md={7} xs={7} lg={7}>
                                    <Grid container spacing={1}>
                                        <Grid item xl={12} md={12} xs={12} lg={12}>
                                            <Typography className={classes.rowPop}>Error</Typography>
                                        </Grid>
                                        <Grid item xl={2} md={2} xs={12} lg={2}>
                                            <Typography className={classes.rowPop}>Paso: </Typography>
                                        </Grid>
                                        <Grid item xl={10} md={10} xs={12} lg={10} className={classes.textCenter}>
                                            <Typography className={classes.rowPop}>{value.nombre_paso}</Typography>
                                        </Grid>
                                        <Grid item xl={2} md={2} xs={12} lg={2}>
                                            <Typography className={classes.rowPop}>Codigo: </Typography>
                                        </Grid>
                                        <Grid item xl={10} md={10} xs={12} lg={10} className={classes.textCenter}>
                                            <Typography className={classes.rowPop} style={{height:"50px"}}>{this.getIcon(value.codigo)}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            :<Grid xl={7} md={7} xs={7} lg={7}>
                                <Typography className={classes.rowPop}>Ok</Typography>
                            </Grid>
                            }
                        </Grid>
                    </Popover>
                        <Typography variant="text" style={{textTransform: "uppercase", fontFamily: "Roboto", padding: "4px 5px", fontSize: "0.8125rem", fontWeight: "500", lineHeight: "1.75"}} className={classes.serviceInfo}>{this.props.match.params.nombre_servicio_unificado}</Typography>
                </div>
            );

        }

        return (
            <Fragment>
                <div className={rootClassName}>
                    <Toolbar className={classes.toolbar}>
                        <IconButton
                            className={classes.menuButton}
                            onClick={onToggleSidebar}
                            variant="text">
                            {isSidebarOpen ? <img src={unfoldLess} style={{fill: "white", width: "34px", height: "34px"}}></img> : <img src={unfoldMore} style={{fill: "white", width: "34px", height: "34px"}}></img>}
                        </IconButton>
                        {/* Bloque de titulo, depende de la sección */}
                        {titleBlock}

                        {/* Servicio de Notificaciones */}
                      {/*   <IconButton
                            className={classes.notificationsButton}
                            onClick={this.handleShowNotifications}>
                            <Badge
                                badgeContent={notificationsCount}
                                color="primary"
                            >
                                <NotificationsIcon />
                            </Badge>
                        </IconButton>
                        */}
                        <IconButton
                            className={classes.FeedbackButton}
                            onClick={this.handleShowFeedback}>
                            <Badge
                                color="error"
                                variant="dot">
                                <Typography variant="button" className={classes.FeedbackButton}>FeedBack</Typography>
                            </Badge>
                        </IconButton>
                        {/* Información de Usuario */}
                        <IconButton
                            className={classes.userInfoButton}
                            onClick={this.handleShowUserInfo}>
                           <UserInfoIcon />     
                        </IconButton>
                        <Typography className={classes.subtitle} variant="h6">
                            {/* @TODO: Agregar Nombre de Usuario - Correo desde API */}
                            {email}
                        </Typography>

                        {/* Sign-Out */}
                        <IconButton
                            className={classes.signOutButton}
                            onClick={this.handleSignOut}>
                            <SignoutIcon />
                        </IconButton>
                    </Toolbar>
                    {sessionStorage.getItem("profile")==="Normal"?null
                        :
                        title=="Online"?
                            <Toolbar className={classes.toolbarMenu}>
                                {/*MENU AGRANDAR*/}
                                
                                {/* Información de Secciones/Herramientas */}
                                <IconButton
                                    className={classes.userInfoButton}
                                    onClick={this.handleSection}
                                    variant="text"
                                >
                                    <MenuIcon />
                                </IconButton>
                                <Typography className={classes.subtitle} variant="h6">
                                    Herramientas | Secciones
                                </Typography>
                                {/*IR A PERIODICOS*/}
                                {/*<IconButton
                                    variant="text"
                                >
                                    <AssessmentIcon />
                                </IconButton>
                                <Typography className={classes.subtitle} variant="h6">
                                    IR A PERIODICOS 
                                </Typography>
                                 <IconButton
                                    variant="text"
                                >
                                    <Switch
                                        checked={this.state.checkedA}
                                        onChange={this.handleSwitch('checkedA')}
                                        value="checkedA"
                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                </IconButton>
                                <Typography className={classes.subtitle} variant="h6">
                                    {checkedA ? 
                                        <Typography style={{color:"white"}}>Expandir</Typography>:
                                        <Typography style={{color:"white"}}>Contraer</Typography>
                                    }
                                </Typography> */}
                            </Toolbar>
                        :null
                        
                    }
                </div>
                <Popover
                    anchorEl={notificationsEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                    onClose={this.handleCloseNotifications}
                    open={showNotifications}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}>
                    <NotificationList
                        notifications={notifications}
                        onSelect={this.handleCloseNotifications}
                    />
                </Popover>

                <Popover
                    anchorEl={userDataEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                    onClose={this.handleCloseUserInfo}
                    open={showUserData}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}>
                    <UserInfo
                        userData={this.state.userData}
                        onSelect={this.handleCloseUserInfo}
                        onClose={this.handleCloseUserInfo}
                    />
                </Popover>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showFeedback}
                    onClose={this.handleCloseFeedback}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showFeedback}>
                        <Feedback handleCloseFeedback={this.handleCloseFeedback}/>
                    </Fade>
                </Modal>
                <Popover
                    anchorEl={sectionEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                    onClose={this.handleSectionClose}
                    open={section}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}>
                    <SectionsTools/>
                </Popover>
            </Fragment>
        );
    }
}

Topbar.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    isSidebarOpen: PropTypes.bool,
    onToggleSidebar: PropTypes.func,
    title: PropTypes.string
};

Topbar.defaultProps = {
    onToggleSidebar: () => { }
};

export default compose(
    withRouter,
    withStyles(styles)
)(Topbar);
